/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Change_Detection_Thumbnail_Prompt_TitleInputs */



/**
* | output |
* | --- |
* | "Generate Marker Thumbnails?" |
*
* @param {Scene_Change_Detection_Thumbnail_Prompt_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const scene_change_detection_thumbnail_prompt_title = /** @type {((inputs?: Scene_Change_Detection_Thumbnail_Prompt_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Change_Detection_Thumbnail_Prompt_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Générer des vignettes de marqueurs ?")
	if (locale === "de") return /** @type {LocalizedString} */ ("Marker-Miniaturansichten generieren?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Generare miniature dei marcatori?")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Создать миниатюры-маркеры?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Generar miniaturas de marcadores?")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("生成标记缩略图？")
	if (locale === "ja") return /** @type {LocalizedString} */ ("マーカーのサムネイルを生成しますか？")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मार्कर थंबनेल कैसे जनरेट करें?")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Gerar miniaturas de marcadores?")
	return /** @type {LocalizedString} */ ("Generate Marker Thumbnails?")
});